var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDriving = function SvgDriving(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 35,
    viewBox: "0 0 17 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75889 28.6797L5.35007 24.4615C5.28153 23.7543 5.59332 23.0639 6.16915 22.6477L8.71744 20.8058C9.40246 20.3106 9.70226 19.4383 9.46638 18.6267L8.3264 14.7043C8.14679 14.0863 8.27555 13.4196 8.67236 12.9129L11.1232 9.78351C11.2801 9.5832 11.3973 9.35478 11.4686 9.11053L12.4811 5.64038",
    stroke: "#1A75D2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1412,
    cy: 5.0204,
    r: 3.5,
    transform: "rotate(16.2657 12.1412 5.0204)",
    fill: "#27BB74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.85883,
    cy: 29.9798,
    r: 3.5,
    transform: "rotate(16.2657 4.85883 29.9798)",
    fill: "#E55353"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDriving);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "driving.1898b14f5d6aaceea88c4757979ae3d4.svg";